import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "./error";


const STALE_SECONDS = 180;

const ACCESS_CONTROL_ERROR_CODES = [401, 403, 429, 503];

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: STALE_SECONDS * 1000,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            throwOnError: true,
            retry: (count, error) => {
                if (isAxiosError(error) && error.status && ACCESS_CONTROL_ERROR_CODES.includes(error.status) ) {
                    return false;
                }
                return count < 3;
            }
        }
    }
});

export default queryClient;
